import React, { useEffect } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useNavigate } from "react-router-dom";

function SessionClosedNotification(props) {

    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.show) {
            localStorage.removeItem("id");
            localStorage.removeItem("token");
        }
    }, [props]);

    const onHide = e => {
        props.hideModal(false);
        navigate("/login")
        window.location.reload();
    }

    return (
        <Modal show={props.show} onHide={onHide} size="lg" backdrop={"static"}>

            <Modal.Header closeButton>
                <Modal.Title><FontAwesomeIcon icon={duotone("triangle-exclamation")} /> {t("sessionclosed")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {
                        !props.wsUnautorized &&
                        <Col>{t("sessionclosedmessage")}</Col>
                    }
                    {
                        props.wsUnautorized &&
                        <Col>{t("sessionclosedconnectionerror")}</Col>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    <FontAwesomeIcon icon={duotone("xmark")} /> {t("close")}
                </Button>
            </Modal.Footer>
        </Modal >
    )
}

export default SessionClosedNotification;